<template>
    <div class="read-book">
        <template v-if="isEpub">
            <select id="toc" style="max-width: 100%;"></select>
            <div class="book" v-touch:swipe="handleSwipe">
                <a id="prev" href="#prev" class="arrow">
                    <el-icon class="el-icon-arrow-left"></el-icon>
                </a>
                <div id="viewer" class="spreads"></div>
                <a id="next" href="#next" class="arrow">
                    <el-icon class="el-icon-arrow-right"></el-icon>
                </a>
                <div class="swipe-box" v-touch:swipe="handleSwipe"></div>
            </div>
        </template>
        <template v-else>
            <iframe :style="{width: '100%', height: pageHeight - 50 + 'px'   }" :src="pdfUrl"></iframe>
        </template>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

const route = useRoute();
const pdfUrl = ref('');
let rendition = null;
const isEpub = ref(false);
const pageHeight = ref(500);
const handleSwipe = (val) => {
    if (val === 'left') {
        rendition.next();
    } else {
        rendition.prev();
    }
};
onMounted(() => {
    const url = decodeURIComponent(route.query.url);
    const title = decodeURIComponent(route.query.title);
    pageHeight.value = document.documentElement.clientHeight;
    isEpub.value = url.includes('.epub');
    if (isEpub.value) {
        loadEpub();
    } else {
        pdfUrl.value = `/pdfjs/web/viewer.html?file=${decodeURIComponent(route.query.url)}`;
    }
    if (title) {
        document.title = title;
    }

});
const loadEpub = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     
    const url = decodeURIComponent(route.query.url);
    let currentSectionIndex = 1;
    let book = ePub(url);
    let options = {
        method: 'default',
        width: '100%',
        spread: 'always',
        height: pageHeight.value - 60
    };
    if (isAndroid) {
        delete options.method ;
    } 
    rendition = book.renderTo('viewer', options);


    rendition.display(currentSectionIndex);
    
    book.ready.then(function () {
        
        let next = document.getElementById('next');

        next.addEventListener('click', function (e) {
            book.package.metadata.direction === 'rtl' ? rendition.prev() : rendition.next();
            e.preventDefault();
        }, false);

        let prev = document.getElementById('prev');
        prev.addEventListener('click', function (e) {
            book.package.metadata.direction === 'rtl' ? rendition.next() : rendition.prev();
            e.preventDefault();
        }, false);

        let keyListener = function (e) {

            // Left Key
            if ((e.keyCode || e.which) == 37) {
                book.package.metadata.direction === 'rtl' ? rendition.next() : rendition.prev();
            }

            // Right Key
            if ((e.keyCode || e.which) == 39) {
                book.package.metadata.direction === 'rtl' ? rendition.prev() : rendition.next();
            }

        };

        rendition.on('keyup', keyListener);
        document.addEventListener('keyup', keyListener, false);
        if (!isAndroid) {
            setTimeout(() => {
                rendition.prev();
                setTimeout(() => {
                    rendition.next();
                    setTimeout(() => {
                        rendition.prev();
                    }, 100);
                }, 100);
            }, 100);
        }
    });

    let title = document.getElementById('title');

    rendition.on('rendered', function (section) {
        let current = book.navigation && book.navigation.get(section.href);

        if (current) {
            let $select = document.getElementById('toc');
            let $selected = $select.querySelector('option[selected]');
            if ($selected) {
                $selected.removeAttribute('selected');
            }

            let $options = $select.querySelectorAll('option');
            for (let i = 0; i < $options.length; ++i) {
                let selected = $options[i].getAttribute('ref') === current.href;
                if (selected) {
                    $options[i].setAttribute('selected', '');
                }
            }
        }

    });

    rendition.on('relocated', function (location) {
        console.log(location);

        let next = book.package.metadata.direction === 'rtl' ? document.getElementById('prev') : document.getElementById('next');
        let prev = book.package.metadata.direction === 'rtl' ? document.getElementById('next') : document.getElementById('prev');

        if (location.atEnd) {
            next.style.visibility = 'hidden';
        } else {
            next.style.visibility = 'visible';
        }

        if (location.atStart) {
            prev.style.visibility = 'hidden';
        } else {
            prev.style.visibility = 'visible';
        }

    });

    rendition.on('layout', function (layout) {
        let viewer = document.getElementById('viewer');

        if (layout.spread) {
            viewer.classList.remove('single');
        } else {
            viewer.classList.add('single');
        }
    });

    window.addEventListener('unload', function () {
        console.log('unloading');
        this.book.destroy();
    });

    book.loaded.navigation.then(function (toc) {
        let $select = document.getElementById('toc'),
            docfrag = document.createDocumentFragment();

        toc.forEach(function (chapter) {
            let option = document.createElement('option');
            option.textContent = chapter.label;
            option.setAttribute('ref', chapter.href);

            docfrag.appendChild(option);
        });

        $select.appendChild(docfrag);

        $select.onchange = function () {
            let index = $select.selectedIndex,
                url = $select.options[index].getAttribute('ref');
            rendition.display(url);
            return false;
        };

    });
};

</script>

<style lang="scss" scoped>
.read-book {
    padding: 30px;
    box-sizing: border-box;
    
    .book {
        display: flex;
        align-items: center;
        position: relative;
        .spreads {
            width: 900px;
            flex: 1;
            flex-shrink: 0;
        }
        .swipe-box {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
        }
        .arrow {
            font-weight: bold;
            font-size: 100px;
            cursor: pointer;
            color: #000;
            position: relative;
            z-index: 100;
        }
    }

    .dark {
        background: #000;
        color: #fff
    }

    .light {
        background: #fff;
        color: #000;
    }

    .tan {
        background: tan;
        color: #ccc;
    }
    
}
@media (max-width: 768px) {
        .arrow {
            width: 150px;
            height: 150px;
            font-size: 12px;
            background: #ccc;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            
        }
    }
</style>
